import { PROJECT_PREFIX } from './lib/eshop-shared-config'

export * from './lib/eshop-shared-config'
export * from './lib/language'

export const API_URI_PREFIX = `/${PROJECT_PREFIX}/api/v1`

export const ACCOUNT_TEST = '0x9f2929051d1f160e37086367d9d4f690af4ac492'
